import React, { useState } from 'react'
import { translate } from '../../selectors/translations'
import { PatientProfileState } from '../../store/PatientProfile/types'
import { Redirect } from 'react-router-dom'
import { openModalWindow } from "../../store/ModalWindowData/action"
import { useDispatch, useSelector } from "react-redux"
import { getLoginCodeSelector } from "../../selectors/patientProfile"
import '../../assets/scss/utils/_grid.scss'
import { dateToAge } from "../../utils/datetime"
import useTranslate from "../../hooks/useTranslate"
import useSWR from "swr"
import { apiV2 } from "../../repositories/repository"

type PropsFromState = {
  patientInfo: PatientProfileState;
  pathname: string;
  onDownloadPDF: () => void;
}

const PatientSideInfo: React.FC<PropsFromState> = (props: PropsFromState) => {
  const [toEditFrom, setToEditForm] = useState(false)
  const [toGameStats, setToGameStats] = useState(false)
  const [toProgram, setToProgram] = useState(false)
  const [inProgram, setInProgram] = useState(false)
  const dispatch = useDispatch()
  const translateLocalazy = useTranslate()
  const {code} = useSelector(getLoginCodeSelector)
  const {patientInfo, pathname, onDownloadPDF} = props
  const requestFamilySurvey = (): void => {
    dispatch(openModalWindow('requestFamilySurvey', {patient: patientInfo}))
  }

  useSWR(
    patientInfo.id ? ['api.program.getForPatient', patientInfo.id] : null,
    () => apiV2.program.getForPatient(patientInfo.id),
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
      dedupingInterval: 0,
      onSuccess: (data) => {
        if (data) {
          setInProgram(true)
        }
      }
    }
  )

  return (
    <div className="p-relative">
      <div className="diagnostic_card card-box shadow">
        <div className="user_personal-info">
          <div className="user-info flex flex-container align-end pb-5">
            <div className="flex flex-item item--12 pb-10 flex--wrap">
              <div className="m-0 t_size_16 t_left pb-10 pr-10">{`${patientInfo.firstName} ${patientInfo.lastName}`}
                <p
                  className="light">{translate(patientInfo.gender)}, {`${dateToAge(patientInfo.birthDate)} ${translate('years')}` || ''} </p>
                {
                  patientInfo.personalNumber && (<p className="light">{patientInfo.personalNumber}</p>)

                }
              </div>
              <h3 className="ml-auto">{translate('loginCode.title')}: <span
                className="t_bold t_uppercase ml-auto">{code} </span></h3>
            </div>
            <div className=" flex-item item--12 pb-10 p-20 w-100">
              <button
                className="g_btn g_btn--outlined w-100"
                type="button"
                onClick={(): void => setToEditForm(true)}>
                {
                  toEditFrom
                    ? <Redirect to={{pathname: `/patient/edit/${patientInfo.id}`, state: {from: pathname}}}/>
                    : translate('editPatientDetails')
                }
              </button>
              <button
                className="g_btn g_btn--outlined w-100 mt-10"
                type="button"
                onClick={(): void => setToGameStats(true)}>
                {
                  toGameStats
                    ? <Redirect to={{pathname: `/patient/game/${patientInfo.id}`, state: {from: pathname}}}/>
                    : translateLocalazy('patient.btn.view-game-stats')
                }
              </button>
              {inProgram && <button
                  className="g_btn g_btn--outlined w-100 mt-10"
                  type="button"
                  onClick={(): void => setToProgram(true)}>
                {
                  toProgram
                    ? <Redirect to={{pathname: `/patient/program/${patientInfo.id}`, state: {from: pathname}}}/>
                    : translateLocalazy('patient.btn.view-program-results')
                }
              </button>}
            </div>
            <div className="twoBtnDiv w-100">
              <button
                className="g_btn g_btn--outlined w-100"
                type="button"
                onClick={onDownloadPDF}>
                {translate('pdfReport')}
              </button>
              <button
                className="g_btn g_btn--outlined w-100"
                type="button"
                onClick={requestFamilySurvey}>

                {translate('requestFamilySurvey')}
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default PatientSideInfo
